"use client";

import { useEffect, useState } from "react";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      if (event.key === "Escape") setMenuOpen(false);
    }
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <header className="header">
      <a
        className="brand"
        href="#oben"
        aria-label="Alex Krenn Startseite"
        onClick={() => setMenuOpen(false)}
      >
        ALEX KRENN
        <span className="brand-dot" />
      </a>
      <nav
        id="navigation"
        className={menuOpen ? "open" : undefined}
        aria-label="Hauptnavigation"
      >
        <a href="#training" onClick={() => setMenuOpen(false)}>
          Das Training
        </a>
        <a href="#alex" onClick={() => setMenuOpen(false)}>
          Über Alex
        </a>
        <a href="#erfahrung" onClick={() => setMenuOpen(false)}>
          Die Erfahrung
        </a>
        <a
          className="nav-contact"
          href="#kontakt"
          onClick={() => setMenuOpen(false)}
        >
          Lass uns starten <span>↗</span>
        </a>
      </nav>
      <button
        className="menu-toggle"
        aria-expanded={menuOpen}
        aria-controls="navigation"
        aria-label={menuOpen ? "Menü schließen" : "Menü öffnen"}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span />
        <span />
      </button>
    </header>
  );
}
